<template>
  <StaffLayout section="Staff Forgot Password">
    <div class="flex flex-col min-h-600">
      <div
        class="m-auto my-10 border-2 border-gray-300 shadow-md rounded-md w-12/12 lg:w-6/12 md:w-8/12 sm:10/12"
      >
        <div class="px-8 py-8 rounded-xl">
          <h1 name="login-title" class="mt-4 mb-2 font-bold text-2xl">
            Forgot your Password?
          </h1>
          <p>Enter your email address below and well send you a link to reset it</p>

          <ErrorDisplay
            :label="resetErrorLabel"
            :message="resetError"
            :isVisible="resetError != null"
          />

          <div v-if="resetRequestSuccess" class="bg-green-200 my-6 p-4">
            <h1 class="text-xl font-bold">Password reset request successful</h1>
            <p>Please check your email for next steps</p>
          </div>

          <form action="" class="mt-6">
            <div class="my-5 text-sm">
              <BaseInput
                label="Email"
                id="email"
                v-model="email"
                type="text"
                autocomplete="username"
                placeholder="Email"
              />
            </div>
            <button
              id="login_button"
              class="w-full p-3 max-w-[120px] py-4 mt-3 rounded text-center text-white duration-300 bg-gray-800 hover:bg-black"
              @click.prevent="resetPassword"
            >
              <span>Send</span>
            </button>
          </form>
        </div>
      </div>
    </div>
  </StaffLayout>
</template>
<script setup lang="ts">
import { useUserStore } from "../../store/userStore";

const userStore = useUserStore();

const router = useRouter();
const route = useRoute();

let isLoading = ref(false);

onMounted(loadData);
onActivated(() => loadData);

async function loadData() {
  console.log("ForgotPassword page loaded");
  isLoading.value = true;
  resetRequestSuccess.value = false;

  await router.isReady();
  let queryEmail = route.query["email"];
  if (queryEmail) email.value = Array.isArray(queryEmail) ? queryEmail[0] : queryEmail;

  isLoading.value = false;
}

let resetErrorLabel = ref<string | null>(null);
let resetError = ref<string | null>(null);
let email = ref("");
// let password = ref("");
// let passwordConfirm = ref("");
let resetRequestSuccess = ref(false);

async function resetPassword() {
  console.log(`Requesting password reset for: ${email.value}`);
  resetRequestSuccess.value = false;
  resetErrorLabel.value = null;
  resetError.value = null;

  if (!email.value || email.value.length < 5) {
    resetErrorLabel.value = "Enter your email";
    resetError.value = "Please enter your account's email address to reset your password";
    return;
  }

  let resultError = await userStore.requestPasswordReset(email.value, "staff");

  if (resultError && resultError.length > 0) {
    resetErrorLabel.value = "Couldn't send reset email";
    resetError.value = resultError;
    resetRequestSuccess.value = false;
  } else {
    resetRequestSuccess.value = true;
  }
}
</script>
